import { Component, Output, EventEmitter, Input, OnInit, inject, viewChild } from '@angular/core';
import { Params } from '@angular/router';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DateUtils } from 'src/app/common/utils/DateUtils';
import { merge, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SnackbarService } from 'src/app/common/services/snackbar-service';
import { IReceiptQuery } from 'src/app/api/api-campaigns.service.generated';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ButtonComponent, MultiLabelsComponent } from 'wecheer-common';


@Component({
  selector: 'app-receipt-filters',
  templateUrl: './receipt-filters.component.html',
  styleUrls: ['./receipt-filters.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    NgxMatTimepickerModule,
    MultiLabelsComponent,
    ButtonComponent
  ]
})
export class ReceiptFiltersComponent implements OnInit {
  private snackBarService = inject(SnackbarService);


  @Input() searchTestReceipts: boolean;
  @Output() search = new EventEmitter<IReceiptQuery>();
  readonly drawerFilters = viewChild<MatDrawer>('drawerFilters');


  form: FormGroup = new FormGroup({
    userPhoneNo: new FormControl(''),
    isDuplicate: new FormControl(''),
    isDuplicateSuspect: new FormControl(''),
    id: new FormControl(''),

    // create date
    createDateGreaterThan: new FormControl(''),
    createDateLessThan: new FormControl(''),
    createTimeGreaterThan: new FormControl(''),
    createTimeLessThan: new FormControl(''),

    // invoice date
    invoiceDateGreaterThan: new FormControl(''),
    invoiceDateLessThan: new FormControl(''),
    invoiceTimeGreaterThan: new FormControl(''),
    invoiceTimeLessThan: new FormControl(''),

    suspectDuplicateGroup: new FormControl(''),
    incomplete: new FormControl(''),
    stages: new FormControl(''),
    invoiceIds: new FormControl(''),
    tags: new FormControl(''),
    campaigns: new FormControl('')
  });

  filter: IReceiptQuery;

  allTags = ['ToReprocess', 'ToCheckFraud', 'ManualAccept', 'ManualReject', 'ToManualVerify', 'ReprocessSuccess', 'ReprocessFail', 'Error', 'Checkby'];

  ngOnInit() {
    this.filter = this.getFormValues();
    this.search.emit(this.filter);
    this.watchDatesAndResetTimeFields();
  }

  setFormValuesFromQueryParams(params: Params) {
    const formValue = {
      ...params,
      createDateGreaterThan: params.createDateGreaterThan ? DateUtils.parseDate(params.createDateGreaterThan) : undefined,
      createDateLessThan: params.createDateLessThan ? DateUtils.parseDate(params.createDateLessThan) : undefined,
      invoiceDateGreaterThan: params.invoiceDateGreaterThan ? DateUtils.parseDate(params.invoiceDateGreaterThan) : undefined,
      invoiceDateLessThan: params.invoiceDateLessThan ? DateUtils.parseDate(params.invoiceDateLessThan) : undefined,
      isDuplicate: params.isDuplicate,
      isDuplicateSuspect: params.isDuplicateSuspect,
      incomplete: params.incomplete,
      stages: params.stages ? Array.isArray(params.stages) ? params.stages : [params.stages] : undefined,
      invoiceIds: params.invoiceIds ? Array.isArray(params.invoiceIds) ? params.invoiceIds : [params.invoiceIds] : undefined,
      tags: params.tags ? Array.isArray(params.tags) ? params.tags : [params.tags] : undefined,
      campaigns: params.campaigns ? Array.isArray(params.campaigns) ? params.campaigns : [params.campaigns] : undefined
    };

    this.form.patchValue(formValue);
  }
  getFormValues(): IReceiptQuery {

    return {
      createDateGreaterThan: this.getFormDateAndTime(this.form.value.createDateGreaterThan, this.form.value.createTimeGreaterThan, false),
      createDateLessThan: this.getFormDateAndTime(this.form.value.createDateLessThan, this.form.value.createTimeLessThan, true),

      invoiceDateGreaterThan: this.getFormDateAndTime(this.form.value.invoiceDateGreaterThan, this.form.value.invoiceTimeGreaterThan, false),
      invoiceDateLessThan: this.getFormDateAndTime(this.form.value.invoiceDateLessThan, this.form.value.invoiceTimeLessThan, true),

      userPhoneNo: this.getFormValue(this.form.value.userPhoneNo),
      id: this.form.value.id,
      isDuplicate: this.form.value.isDuplicate == '' ? undefined : this.form.value.isDuplicate ? this.form.value.isDuplicate.toString() == 'true' : undefined,
      isDuplicateSuspect: this.form.value.isDuplicateSuspect == '' ? undefined : this.form.value.isDuplicateSuspect ? this.form.value.isDuplicateSuspect.toString() == 'true' : undefined,
      // tags: this.getFormValue(this.form.value.tags),

      suspectDuplicateGroup: this.getFormValue(this.form.value.suspectDuplicateGroup),
      incomplete: this.form.value.incomplete == '' ? undefined : this.form.value.incomplete ? this.form.value.incomplete.toString() == 'true' : undefined,
      stages: this.getStringArrayFormValue(this.form.value.stages),
      invoiceIds: this.getStringArrayFormValue(this.form.value.invoiceIds),
      tags: this.getStringArrayFormValue(this.form.value.tags),
      campaigns: this.getStringArrayFormValue(this.form.value.campaigns)
    };
  }

  getFormDateAndTime(formDate: string, fromTime: string, endOfDay: boolean): Date {
    const date = formDate ? new Date(formDate) : undefined;
    DateUtils.setTime(date, fromTime, endOfDay);
    return date;
  }

  // Helper method to get undefined if the formValue is null (to be compatible with the automatically generated client class)
  getFormValue(formValue: any) {
    return formValue || undefined;
  }

  getStringArrayFormValue(formValue: any) {
    if (formValue && formValue.length) return formValue;
    return new Array<string>();
  }

  onReset() {
    this.form.reset({ maxProbability: 1.0, maxFocusScore: 1.0 });
    this.onSubmit();
  }

  onSubmit() {
    this.filter = this.getFormValues();
    this.search.emit(this.filter);
    this.drawerFilters().close();
  }

  open() {
    this.drawerFilters().open();
  }

  encodeArray(arr: string[]): string {
    return arr && arr.length ? arr.join('----') : null;
  }
  decodeArray(arr: string): string[] {
    return arr ? arr.split('----') : null;
  }

  unique_id() {
    return 'xxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  watchDatesAndResetTimeFields() {
    const configs = [
      // createDate + time
      {
        dateFieldName: 'createDateGreaterThan',
        timeFieldName: 'createTimeGreaterThan',
        defaultTimeValue: '00:00'
      },
      {
        dateFieldName: 'createDateLessThan',
        timeFieldName: 'createTimeLessThan',
        defaultTimeValue: '23:59'
      },
      // invoiceDate + time
      {
        dateFieldName: 'invoiceDateGreaterThan',
        timeFieldName: 'invoiceTimeGreaterThan',
        defaultTimeValue: '00:00'
      },
      {
        dateFieldName: 'invoiceDateLessThan',
        timeFieldName: 'invoiceTimeLessThan',
        defaultTimeValue: '23:59'
      },
    ];

    const observables = configs.map(config =>
      this.form.get(config.dateFieldName).valueChanges
        .pipe(map(dateFieldValue => {
          return {
            config,
            dateFieldValue
          };
        }))
    );

    merge(...observables).subscribe(({ config, dateFieldValue }) => {
      const formValue: { [k: string]: any } = {};
      if (dateFieldValue) {
        // changed to a valid date
        // get time and if it is not set - set it to default
        const crtTime = this.form.value[config.timeFieldName];
        if (!crtTime) {
          formValue[config.timeFieldName] = config.defaultTimeValue;
          this.form.patchValue(formValue);
        }
      } else {
        formValue[config.timeFieldName] = null;
        // removed date filter - clear time also
        this.form.patchValue(formValue);
      }
    });
  }

  async onTimePickerTryOpen(isDisabled: boolean) {
    if (isDisabled) {
      this.snackBarService.open('Please select a date first!');
    }
  }

  compareBoolFn = (a: any, b: any) => a == b;

  availableLabels() {
    return of(this.allTags);
  }
}
